import React from "react";
import { useQuery } from "react-apollo-hooks";
import { EXCHANGEREQUEST_CONFIG_QUERY } from "../../Queries";
import InitPresenter from "./Presenter/Init";
import Container from "./Container";

export default () => {
  const { data, loading } = useQuery(EXCHANGEREQUEST_CONFIG_QUERY);

  if (loading) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }

  if (!loading && data.AdminExchangeRequestConfig) {
    return (
      <>
        <Container config={data}></Container>
      </>
    );
  }

  if (!loading && !data.AdminExchangeRequestConfig) {
    return (
      <>
        <InitPresenter></InitPresenter>
      </>
    );
  }
};
